import {addedDiff} from 'deep-object-diff';
import {useRouter} from 'next/router';
import {useCallback, useEffect, useState} from 'react';

import {SEARCH_FILTERS} from '@/src/app/constants/search';

export interface pageSettingsProps {
  [keys: string]: string;
}

interface usePaginationProps {
  initialSettingsPage: pageSettingsProps;
  callback: (...args) => Promise<void>;
}

const usePagination = ({initialSettingsPage, callback}: usePaginationProps) => {
  const router = useRouter();
  const {query, isReady} = router;
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    if (!isReady) {
      return;
    }

    const comparedQuery = checkIsAllQuerySettled(query, initialSettingsPage);

    if (Object.keys(comparedQuery).length) {
      setInitialData({
        ...query,
        ...comparedQuery,
      });

      return null;
    }

    fetchData(query);
  }, [isReady, JSON.stringify(query)]);

  const fetchData = async (query) => {
    setIsFetching(true);
    await callback(query);
    setIsFetching(false);
  };

  const setInitialData = useCallback(
    (newQuery) => {
      const pathname = router.asPath.split('?')[0];

      router.replace({
        pathname: pathname,
        query: {
          ...newQuery,
        },
      });
    },
    [router]
  );

  const onPageChange = useCallback(
    (newValue) => {
      const pathname = router.asPath.split('?')[0];

      router.push({
        pathname: pathname,
        query: {
          ...router.query,
          offset: `${
            Number(newValue.selected) *
            Number(initialSettingsPage[SEARCH_FILTERS.PER_PAGE])
          }`,
        },
      });
    },
    [router]
  );

  return {
    onPageChange,
    isFetching,
    query: {
      ...initialSettingsPage,
      ...query,
    },
  };
};

export default usePagination;

export const checkIsAllQuerySettled = (currentQuery, initialQuery) => {
  return addedDiff(currentQuery, initialQuery);
};
